/**
 * 회원 관리 하위 탭 네비게이션
 *
 * 사이드바 메뉴는 "회원 관리" 하나로 유지하되, 그 아래 실제 기능은
 * 여러 페이지(회원 목록 / 배터리 관리)로 나뉘어 있어서 그 사이를 오가는 탭.
 * AdminLayout의 NAV_ITEMS는 평면 구조라 사이드바에 서브메뉴를 두지 않고,
 * 각 페이지 상단에 이 탭을 공통으로 넣어 "회원 관리 하위" 임을 드러낸다.
 */
import { Link } from "react-router-dom";

const TABS = [
  { key: "list",    to: "/admin/member",         icon: "fas fa-users",         label: "회원 목록" },
  { key: "battery", to: "/admin/member/battery",  icon: "fas fa-battery-full",  label: "배터리 관리" },
] as const;

interface MemberSubNavProps {
  active: (typeof TABS)[number]["key"];
}

export default function MemberSubNav({ active }: MemberSubNavProps) {
  return (
    <div className="flex gap-2 mb-6">
      {TABS.map(({ key, to, icon, label }) => (
        <Link
          key={key}
          to={to}
          className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-all inline-flex items-center gap-2 ${
            active === key
              ? "bg-gradient-to-r from-primary to-[#5FA060] text-white shadow-md"
              : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-200"
          }`}
        >
          <i className={icon}></i>
          {label}
        </Link>
      ))}
    </div>
  );
}
